import React, { useEffect, useState, useRef } from 'react';
import cx from 'classnames';
import { Switch, Route, Redirect, NavLink } from 'react-router-dom';

// @material-ui/core components
import { withStyles, makeStyles } from '@material-ui/core/styles';

// core components
import * as AuthService from '../core/auth/auth-actions';
import { SidebarLayout, PrivateRoute, PublicRoute } from '@intervan-ar/ov-componentes';
import mainRoutes from '../routes/main';
import { getLogo } from '../core/params.js';
import ServiceOffline from './ServiceOffline.js';
import { browserHistory, getFullUrl } from '../core/globals';
import { useSelector, useDispatch } from 'react-redux';
import { setConsultaDinamica } from '../core/consultaDinamica/consultaDinamica-actions';

// Style
import style from './MainLayoutStyle';

const useStyles = makeStyles(style);

const roleAccessor = "perfiles";

const MainLayout = props => {
  const dispatch = useDispatch();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [miniActive, setMiniActive] = useState(false);
  const [logo, setLogo] = useState(null);
  const mainPanelRef = useRef(null);
  const parametros = useSelector(state => {
    return state.parametros.data;
  });
  const system = useSelector(state => {
    return state.system;
  });
  const extraClasses = useStyles();

  const user = useSelector(state => {
    return state.auth.user;
  });
  const loading = useSelector(state => {
    return state.auth.loadingUser;
  });
  const initialMessage = useSelector(state => {
    return state.auth.showInitialMessage;
  });
  const popUpLogin = useSelector(state => {
    return state.auth.popUpLogin ? state.auth.popUpLogin : false;
  });

  useEffect(() => {
    if(parametros?.OV_PROVEEDORES_CONSULTAS_DINAMICAS?.valor !== undefined) {
      try {
        let data = JSON.parse(parametros?.OV_PROVEEDORES_CONSULTAS_DINAMICAS?.valor);
        dispatch(setConsultaDinamica(data.consultas));
      }
      catch(error) {
        console.log("Error al cargar consultas dinámicas");
      }
    }
  }, [parametros.OV_PROVEEDORES_CONSULTAS_DINAMICAS, dispatch]);

  useEffect(() => {
    let unmounted = false;
    const init = async () => {
      try {
      var logo = await getLogo();
      }
      catch(error) {
        console.log("Error al obtener logo");
      }

      if(!unmounted) setLogo(logo);

      window.addEventListener('resize', resizeFunction);
    };
    init();
    return () => {
      window.removeEventListener('resize', resizeFunction);
    };
  }, []);

  useEffect(() => {
    if (props.history.location.pathname !== props.location.pathname) {
      mainPanelRef.current.scrollTop = 0;
      if (mobileOpen) {
        setMobileOpen(false);
      }
    }
  }, [props.history, props.location, mobileOpen]);

  const handleDrawerToggle = () => {
    if (window.innerWidth <= 960) {
      setMobileOpen(!mobileOpen);
    }
  };

  const sidebarMinimize = () => {
    setMiniActive(!miniActive);
  };

  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };

  const renderRoutes = () => {
    const componentProps = {
      headerProps: {
        sidebarMinimize: sidebarMinimize,
        miniActive: miniActive,
        routes: mainRoutes(parametros),
        handleDrawerToggle: handleDrawerToggle,
        location: props.location,
      },
    };

    return (
      <Switch>
        {mainRoutes(parametros).map((prop, key) => {
          if (!prop?.views) {
            if (prop.redirect)
              return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
            if (prop.private)
              return (
                <PrivateRoute
                  path={prop.path}
                  component={prop.component}
                  key={key}
                  componentProps={componentProps}
                  authService={AuthService}
                  routeComponent={Route}
                  redirectComponent={Redirect}
                  redirectTo={getFullUrl('inicio')}
                  useDispatch={dispatch}
                  route={prop}
                  roleAccessor={roleAccessor}
                  user={user}
                />
              );
            if (prop.public)
              return (
                <PublicRoute
                  path={prop.path}
                  component={prop.component}
                  key={key}
                  componentProps={componentProps}
                  routeComponent={Route}
                />
              );
            return (
              <Route path={prop.path} component={prop.component} key={key} />
            );
          } else {
            const { views } = prop;

            return views.map((route, i) => (
              <PrivateRoute
                path={route.path}
                component={route.component}
                key={i}
                componentProps={componentProps}
                authService={AuthService}
                routeComponent={Route}
                useDispatch={dispatch}
                redirectComponent={Redirect}
                redirectTo={getFullUrl('inicio')}
                route={route}
                roleAccessor={roleAccessor}
                user={user}
              />
            ));
          }
        })}
      </Switch>
    );
  };

  const { classes, ...rest } = props;
  const mainPanel =
    classes.mainPanel +
    ' ' +
    cx({
      [classes.mainPanelSidebarMini]: miniActive
    });

  if (system && system.systemOffline) {
    if (
      browserHistory.location.pathname !==
      `${process.env.REACT_APP_BASE_URL}inicio`
    )
      browserHistory.push(getFullUrl('inicio'));
    else return <ServiceOffline />;
  }

  return (
    <div className={classes.wrapper}>
      <SidebarLayout
        routes={mainRoutes(parametros)}
        logo={logo}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color="purple"
        bgColor="white"
        miniActive={miniActive}
        user={user}
        loading={loading}
        popUpLogin={popUpLogin}
        initialMessage={initialMessage}
        parametros={parametros}
        getFullUrl={getFullUrl}
        authService={AuthService}
        dispatch={dispatch}
        onMyProfile={() => {props.history.replace(getFullUrl('my-profile'));}}
        history={props.history}
        navLinkComponent={NavLink}
        roleAccessor={roleAccessor}
        {...rest}
      />
      <div id="mainScrollAnchor" className={mainPanel} ref={mainPanelRef}>
        {renderRoutes()}
      </div>
    </div>
  );
};

export default (withStyles(style)(MainLayout));
